/**
 * Absolute paths for the Regulatory References section's tab routes — same
 * rationale as `compliance-reviews/routes.ts`: the child's `to`, the router
 * record and (for Completed/Not Required, added by SMCR-316/SMCR-346) each
 * tab's own list table all import from here rather than retyping the string.
 */
export const REGULATORY_REFERENCES_PATH = '/regulatory-references'
export const REGULATORY_REFERENCES_COMPLETED_PATH = '/regulatory-references/completed'
export const REGULATORY_REFERENCES_NOT_REQUIRED_PATH = '/regulatory-references/not-required'
